import { createContext, useContext, useEffect, useMemo } from "react";
import { StartLink } from "../../data/Navigation";
import { INavigationLink } from "../../interfaces/INavigation";
import { useCallback } from 'react';
import { useAuthContext } from "../AuthContext";
import NavigationHelper from "../../helpers/NavigationHelper";
import FormHelper from "../../helpers/FormHelper";
import UserService from "../../services/UserService";
import useState from "../../hooks/useState";


interface INavigationContext {
    selectedNavigationLink: INavigationLink;
    setSelectedNavigationLink: (navLink: INavigationLink) => void;
}

interface IStateValues {
    selectedNavigationLink: INavigationLink;
}


const NavigationContext = createContext<INavigationContext | undefined>(undefined);

const NavigationContextProvider = (props: React.PropsWithChildren) => {
    const { hasPermission } = useAuthContext();

    const state = useState<IStateValues>({
        selectedNavigationLink: StartLink
    });


    useEffect(() => {
        const navigationItems = NavigationHelper.FilterItems(n => hasPermission(n.alias[0]));
        if (navigationItems.length === 1) {
            state.update('selectedNavigationLink', navigationItems[0]);
        }
        // eslint-disable-next-line
    }, []);


    const handleChangeSelectedNavigationLink = useCallback((navLink: INavigationLink) => {
        if (navLink.alias.length > 0) {
            let formData = FormHelper.Create(undefined);
            formData = FormHelper.Add(formData, 'permissionAlias', navLink.alias[0]);

            UserService.UpdateRecentAccess(formData);
        }

        state.update('selectedNavigationLink', navLink);
        // eslint-disable-next-line
    }, []);

    

    const data: INavigationContext = useMemo(() => {
        return {
            selectedNavigationLink: state.values.selectedNavigationLink,
            setSelectedNavigationLink: handleChangeSelectedNavigationLink
        };

        // eslint-disable-next-line
    }, [state.values]);

    return (
        <NavigationContext.Provider value={data}>
            {props.children}
        </NavigationContext.Provider>
    );
}


const useNavigationContext = () => {
    const context = useContext(NavigationContext);

    if (context === undefined) {
        throw new Error('useNavigationContext must be used within a NavigationContextProvider');
    }

    return context;
}

export {
    useNavigationContext
}

export default NavigationContextProvider;